import React from "react";
import { DeleteWithConfirmButton, useRecordContext } from "react-admin";

export const ShippingAddressDeleteButton = props => {
  const record = useRecordContext();
  return (
    <DeleteWithConfirmButton
      confirmContent="This record will be deleted. Do you want to continue?"
      confirmTitle="Delete Shipping Address"
      resource="shippingaddresss"
      record={{ id: record.id }}
      redirect={false}
      mutationMode="pessimistic"
    />
  );
};
